/* eslint-disable jsx-a11y/anchor-is-valid */
// @flow
import React, { useState, useEffect } from 'react';
// components
import Table from '../../components/Table';
import { useTranslation } from 'react-i18next';
import { Loading } from 'react-loading-ui';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux';
import { getPerformance, getUserRequestAPI } from '../../API/RDPMS_API';
import moment from 'moment';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'material-design-icons/iconfont/material-icons.css';
import '../../../src/assets/scss/custom/components/_alert.scss';
import '../dashboard/Dashboard/Dashboard.css';
import MultiSelectDropdown from '../../components/MultiSelectDropdown';
import { mapRequestDataToOptions, performanceColumns, sizePerPageList } from './requestDataMapper';

import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import PieChartComponent from '../../components/Charts/PieChartComponent';
import BarChartComponent from '../../components/Charts/BarChartComponent';
import GraphChartComponent from '../../components/Charts/GraphChartComponent';
import HyperDatepicker from '../../components/Datepicker';

const Performance = () => {
    const { auth } = useSelector((state) => ({
        auth: state.Auth,
    }));
    const userRole = auth?.user?.role;

    const [data, setData] = useState([]);
    const [limit, setLimit] = useState(5);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [totalCount, setTotalCount] = useState(0);

    const [selectedViews, setSelectedViews] = useState({ value: 'table', label: 'Table' });

    const [pieData, setPieData] = useState([]);
    const [barData, setBarData] = useState([]);
    const [graphData, setGraphData] = useState([]);

    const [selectedStartDate, setSelectedStartDate] = useState(() => {
        const today = new Date();
        const last7Days = new Date();
        last7Days.setDate(today.getDate() - 7);
        return last7Days;
    });

    const [selectedEndDate, setSelectedEndDate] = useState(new Date());

    const [selectedZones, setSelectedZones] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
    ]);
    const [selectedDivisions, setSelectedDivisions] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
    ]);
    const [selectedStation, setSelectedStation] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
    ]);

    const [zones, setZones] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [stations, setStations] = useState([]);

    const [statusMessage, setStatusMessage] = useState('');

    useEffect(() => {
        const fetchStation = async () => {
            await getRequestData(auth.user.id);
        };

        fetchStation();
    }, []);

    useEffect(() => {
        if (stations && stations.length > 0) {
            getPerformanceData(limit, pageNumber);
        }
    }, [stations]);

    const formatDateTime = (date) => {
        if (!date) return {};

        return {
            date: `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(
                2,
                '0'
            )}/${date.getFullYear()}`,
            time: `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(
                date.getSeconds()
            ).padStart(2, '0')}`,
        };
    };

    const getPerformanceData = async (limits, pages) => {
        Loading();
        // let limitNumber = limits ? limits : limit;
        // let pagesNumber = pages ? pages : pageNumber;

        let limitNumber = limits ?? limit;
        let pagesNumber = pages ?? pageNumber;

        const { date: start_date, time: start_time } = formatDateTime(selectedStartDate);
        const { date: end_date, time: end_time } = formatDateTime(selectedEndDate);

        const zone = selectedZones.some((z) => z.value === 'all') ? [] : selectedZones.map((z) => z.value);

        const division = selectedDivisions.some((d) => d.value === 'all') ? [] : selectedDivisions.map((d) => d.value);

        // const station = selectedStation.some((s) => s.value === 'all') ? [] : selectedStation.map((s) => s.value);
        let station = [];
        if (userRole === 'super admin') {
            // Existing logic
            station = selectedStation.some((s) => s.value === 'all') ? [] : selectedStation.map((s) => s.value);
        } else {
            //  user station select
            if (selectedStation.length > 0 && !selectedStation.some((s) => s.value === 'all')) {
                station = selectedStation.map((s) => s.value);
            } else {
                // not select station select  → get stations state
                station = stations.filter((s) => s.value !== 'all').map((s) => s.value);
            }
        }

        let request = {
            start_date: start_date,
            start_time: start_time,

            end_date: end_date,
            end_time: end_time,
            request: {
                zone: zone,
                division: division,
                station: station,
            },
            page_number: pagesNumber,
            page_size: limitNumber,
        };

        // console.log(request, 'request.........');

        let response = await getPerformance(request);
        // console.log(response, 'response.........');

        if (response) {
            let srNo = pagesNumber * limitNumber - limitNumber + 1;
            const dataArray = [];

            // Category-wise totals for charts
            const pieDataMap = {};
            const barDataMap = {};
            const graphDataMap = {};

            // Legend mapping → display names for charts
            const legendNames = {
                Failure: '% of (True + Partially True) Failure Alerts out of total Failure Alerts',
                Predictive: '% of (True + Partially True) Predictive Alerts out of total Predictive Alerts',
                'Actual Alert': '% of (True + Partially True) Failure Alerts',
            };

            // Loop through response
            response?.zone?.forEach((zone) => {
                zone.division?.forEach((division) => {
                    division.station?.forEach((station) => {
                        const failure = station.fail_alert_per ?? 0;
                        const predictive = station.pred_alert_per ?? 0;
                        const actualAlert = station.actual_fail_alert_per ?? 0;

                        // Update category-wise totals for Pie, Bar, Graph
                        ['Failure', 'Predictive', 'Actual Alert'].forEach((key) => {
                            const value = key === 'Failure' ? failure : key === 'Predictive' ? predictive : actualAlert;

                            pieDataMap[key] = (pieDataMap[key] || 0) + value;
                            barDataMap[key] = (barDataMap[key] || 0) + value;
                            graphDataMap[key] = (graphDataMap[key] || 0) + value;
                        });

                        // Table data
                        dataArray.push({
                            srNo: srNo++,
                            zoneCode: zone.zc || '',
                            divisionCode: division.dc || '',
                            stationCode: station.sc || '',
                            failure,
                            predective: predictive,
                            actualAlert,
                        });
                    });
                });
            });

            // Convert maps → arrays for charting
            const pieArray = Object.keys(pieDataMap).map((key) => ({
                name: legendNames[key] || key,
                value: pieDataMap[key],
            }));

            const barArray = Object.keys(barDataMap).map((key) => ({
                name: legendNames[key] || key,
                total: barDataMap[key],
            }));

            const graphArray = Object.keys(graphDataMap).map((key) => ({
                name: legendNames[key] || key,
                value: graphDataMap[key],
            }));

            // Set chart states
            setPieData(pieArray);
            setBarData(barArray);
            setGraphData(graphArray);

            // Set table & pagination states
            setData(dataArray);
            setPageNumber(response?.pagination?.currentPage);
            setPageCount(response?.pagination?.totalPages);
            setTotalCount(response?.pagination?.totalCount);

            setStatusMessage('Performance details fetched successfully');
        }

        Loading();
    };

    const getRequestData = async (id) => {
        try {
            Loading(true);

            const response = await getUserRequestAPI(id);
            // console.log(response, 'getUserRequestAPI response....');

            if (response) {
                const { stations, zones, divisions } = mapRequestDataToOptions(response);

                // Component state me directly set
                setStations(stations);
                setZones(zones);
                setDivisions(divisions);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            Loading(false);
        }
    };

    //pagination
    const handlePageChange = async (value) => {
        setPageNumber(1);
        setLimit(value);
        await getPerformanceData(value, 1);
    };

    const handlePageClick = async (value) => {
        setPageNumber(value);
        await getPerformanceData(limit, value);
    };

    const viewOptions = [
        { label: 'Table', value: 'table' },
        { label: 'Pie', value: 'pie' },
        { label: 'Bar', value: 'bar' },
        { label: 'Graph', value: 'graph' },
    ];

    const handleSelectView = async (e) => {
        if (e?.value === 'table') {
            await getPerformanceData(5, 1);
        } else {
            await getPerformanceData(0, 0);
        }
        setSelectedViews(e);
    };

    const downloadPerformanceExcel = () => {
        const exportData = data.map((row) => ({
            'Sr No': row.srNo,
            'Zone Code': row.zoneCode,
            'Division Code': row.divisionCode,
            'Station Code': row.stationCode,
            '% of (True + Partially True) Failure Alerts out of total Failure Alerts generated': row.failure,
            '% of (True + Partially True) Predictive Alerts out of total Predictive Alerts generated': row.predective,
            '% of (True + Partially True) Failure Alerts by RDPMS out of total actual failures occurred at station':
                row.actualAlert,
        }));

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Performance Details');

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
        });

        saveAs(blob, 'Performance_Details.xlsx');
    };
    return (
        <>
            <ToastContainer />

            <div className=" py-3 " style={{ width: '100%' }}>
                <div className="container-fluid px-0">
                    <div className="row align-items-center gx-2 gy-2">
                        {/* Alerts Overview Button */}
                        <div className="col-12 col-md-auto">
                            <button className="btn_1 w-100" style={{ marginLeft: '0' }}>
                                Performance
                            </button>
                        </div>
                    </div>
                </div>

                <div
                    className="report-alert-card my-2 p-1"
                    style={{
                        width: '100%',
                        boxShadow: '0px 0px 35px 0px rgba(154, 161, 171, 0.15)',
                        position: 'relative',
                        height: 'auto',
                    }}>
                    {/* sirf container aur spacing update */}
                    <div
                        className="container-fluid"
                        style={{
                            paddingLeft: '10px',
                            paddingRight: '10px',
                        }}>
                        <form>
                            <div className="row d-flex gx-3 gy-2">
                                <div className="col-md-3 form-group">
                                    <label htmlFor="startDate">Start Date</label>

                                    <div className="custom-datepicker-wrapper">
                                        <HyperDatepicker
                                            hideAddon={true}
                                            type="date"
                                            className="form-control"
                                            dateFormat="yyyy-MM-dd h:mm aa"
                                            value={selectedStartDate}
                                            maxDate={new Date()}
                                            showTimeSelect={true}
                                            timeFormat="h:mm aa"
                                            timeIntervals={15}
                                            onChange={(date) => setSelectedStartDate(date)}
                                        />
                                    </div>

                                    {selectedStartDate && (
                                        <div className="mt-1 text-muted" style={{ fontSize: '13px' }}>
                                            Selected date: {moment(selectedStartDate).format('dddd, MMMM Do, YYYY')}
                                        </div>
                                    )}
                                </div>

                                <div className="col-md-3 form-group">
                                    <label htmlFor="endDate">End Date</label>

                                    <div className="custom-datepicker-wrapper">
                                        <HyperDatepicker
                                            hideAddon={true}
                                            type="date"
                                            className="form-control"
                                            defaultValue="2024-08-22"
                                            id="endDate"
                                            dateFormat="yyyy-MM-dd h:mm aa"
                                            value={selectedEndDate}
                                            maxDate={new Date()}
                                            showTimeSelect={true}
                                            timeFormat="h:mm aa"
                                            timeIntervals={15}
                                            onChange={(date) => {
                                                setSelectedEndDate(date);
                                            }}
                                        />
                                    </div>

                                    {selectedEndDate && (
                                        <div className="mt-1 text-muted" style={{ fontSize: '13px' }}>
                                            Selected date: {moment(selectedEndDate).format('dddd, MMMM Do, YYYY')}
                                        </div>
                                    )}
                                </div>

                                <MultiSelectDropdown
                                    label="Zones"
                                    id="zoneSelect"
                                    options={zones}
                                    selectedValues={selectedZones}
                                    onChange={setSelectedZones}
                                />

                                <MultiSelectDropdown
                                    label="Divisions"
                                    id="divisionSelect"
                                    options={divisions}
                                    selectedValues={selectedDivisions}
                                    onChange={setSelectedDivisions}
                                />

                                <MultiSelectDropdown
                                    label="Station"
                                    id="stationSelect"
                                    options={stations}
                                    selectedValues={selectedStation}
                                    onChange={setSelectedStation}
                                />

                                <MultiSelectDropdown
                                    label="View"
                                    id="viewSelect"
                                    options={viewOptions}
                                    selectedValues={selectedViews}
                                    onChange={(e) => {
                                        handleSelectView(e);
                                    }}
                                    isMulti={false}
                                />
                            </div>

                            <div className="row mt-2">
                                <div className="col-md-12 text-end">
                                    <button
                                        type="button"
                                        className="btn"
                                        onClick={() => getPerformanceData(5, 1)}
                                        style={{
                                            backgroundColor: '#F9B74C',
                                            color: 'black',
                                            fontWeight: 'bold',
                                            width: '150px',
                                            textTransform: 'uppercase',
                                            fontFamily: "'Poppins', sans-serif",
                                            fontSize: '14px',
                                        }}>
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                {(!selectedViews || selectedViews?.value === 'table') && data?.length > 0 && (
                    <div
                        className="col-sm-12 card-alerts my-2 p-2 border-0  text-start no-radius"
                        style={{ width: '100%', position: 'relative' }}>
                        <span
                            onClick={downloadPerformanceExcel}
                            style={{
                                position: 'absolute',
                                top: '15px',
                                right: '15px',
                                border: '1px solid #ccc',
                                padding: '10px 10px',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                            <i className="fa fa-download"></i>
                        </span>

                        <Table
                            columns={performanceColumns}
                            data={data}
                            pageSize={limit}
                            pageCount={pageCount}
                            pageNumber={pageNumber}
                            totalCount={totalCount}
                            sizePerPageList={sizePerPageList}
                            isSortable={true}
                            pagination={true}
                            isSearchable={true}
                            onPageChange={handlePageChange}
                            onPageClick={handlePageClick}
                        />
                    </div>
                )}

                {selectedViews?.value === 'pie' && pieData?.length > 0 && (
                    <div
                        className="col-sm-12 card-alerts my-2 p-2 border-0 text-start no-radius"
                        style={{ width: '100%', position: 'relative' }}>
                        <PieChartComponent data={pieData || []} />
                    </div>
                )}

                {selectedViews?.value === 'bar' && barData?.length > 0 && (
                    <div
                        className="col-sm-12 card-alerts my-2 p-2 border-0 text-start no-radius"
                        style={{ width: '100%', position: 'relative' }}>
                        <BarChartComponent data={barData || []} />
                    </div>
                )}

                {selectedViews?.value === 'graph' && graphData?.length > 0 && (
                    <div
                        className="col-sm-12 card-alerts my-2 p-2 border-0 text-start no-radius"
                        style={{ width: '100%', position: 'relative' }}>
                        <GraphChartComponent data={graphData || []} />
                    </div>
                )}
            </div>

            <div className="modal fade" id="statusModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button
                                type="button"
                                className="btn-close ms-auto"
                                data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                        <div className="modal-body text-center">
                            <img
                                src="/asset-images/checkmark.png"
                                alt="Success"
                                className="img-fluid"
                                style={{ maxWidth: '100px' }}
                            />
                            <p className="mt-2">{statusMessage}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Performance;
